import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import Box from '../components/box';
import Head from '../components/head';


export default function About({ data }) {
  console.log(data)
  const post = data.aboutJson
  return (
    <Layout>
    <Head pageTitle={post.title} />
    <Box>
      <div
        dangerouslySetInnerHTML={{
          __html: post.content.childMarkdownRemark.html,
        }}
      />
    </Box>
  </Layout>
  );
}

export const query = graphql`
  query AboutQuery {
    aboutJson {
      title
      content {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
